import { useState } from 'react';
import type { DataTableRowEventHandler } from '@/components/custom/erp';
import type { WardTableRow } from '../cols-definition';

interface UseRowSelectionReturn {
  selectedObj: WardTableRow | null;
  selectedRowIndex: string | null;
  handleRowClick: DataTableRowEventHandler<WardTableRow>;
  clearSelection: () => void;
}

export const useRowSelection = (): UseRowSelectionReturn => {
  const [selectedObj, setSelectedObj] = useState<WardTableRow | null>(null);
  const [selectedRowIndex, setSelectedRowIndex] = useState<string | null>(null);

  const handleRowClick: DataTableRowEventHandler<WardTableRow> = params => {
    if (params.row.id === 'total') return;

    setSelectedRowIndex(params.id.toString());
    setSelectedObj(params.row);
  };

  const clearSelection = () => {
    setSelectedObj(null);
    setSelectedRowIndex(null);
  };

  return {
    selectedObj,
    selectedRowIndex,
    handleRowClick,
    clearSelection
  };
};
